var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chat-introduction chat-item-text"},[_c('div',{staticClass:"introduction-text-container"},[_c('div',{staticClass:"introduction-text"},[_vm._v(" "+_vm._s(_vm.introductionText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }